export const mapToSelectWithOrder = (data) =>
  data
    .slice()
    .sort((a, b) => a.ordinal - b.ordinal)
    .map((row, index) => ({
      key: row.id,
      value: row.id,
      text: `${index + 1} - ${row.name}`,
  }));

export const mapToSelect = (data) =>
  data.map((row) => {
    return { key: row.id, value: row.id, text: row.name };
});

export const mapOfficersToOptions = (response) => {
  return response.data.map((x) => ({
    key: x.id,
    text: `${x.name} (${x.badgeNumber})`,
    value: x,
  }));
};

export const mapStatusCounts = (data) => {
  return data.map((x) => ({
    key: x.id,
    color: x.colour.toLowerCase(),
    quantity: x.count,
    text: x.name,
    disabled: x.disabled,
  }));
};

export const mapStatus = (data) => {
  return data.map((x) => ({
    key: x.id,
    color: x.colour.toLowerCase(),
    quantity: 0,
    text: x.name,
    disabled: false,
  }));
};

export const isAlphaNumeric = (str) => {
  return /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/.test(str);
};

export const isNumeric = (str) => {
  return /^\d+$/.test(str);
};
